<template>
  <RadioGroup
    :model-value="modelValue"
    :disabled="disabled"
    class="flex flex-col gap-2"
    @update:model-value="onUpdate"
  >
    <RadioGroupLabel
      v-if="label"
      class="font-medium text-gray-700 capitalize-first dark:text-gray-300"
    >
      {{ label }}
    </RadioGroupLabel>
    <div class="grid grid-cols-1 gap-3 @lg/dossier-main:grid-cols-3">
      <RadioGroupOption
        v-for="option in options"
        :key="option[trackBy]"
        v-slot="{ active, checked }"
        as="template"
        :value="option[trackBy]"
      >
        <div
          :class="[
            active
              ? 'ring-2 ring-white/60 ring-offset-2 ring-offset-primary-300'
              : '',
            checked
              ? 'bg-primary-500 text-white'
              : 'bg-gray-200 text-gray-900 hover:bg-gray-300 dark:bg-slate-600 dark:text-gray-100',
            disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
          ]"
          class="relative flex items-center justify-between gap-3 rounded-lg px-5 py-4 shadow-md focus:outline-hidden"
        >
          <span class="text-sm font-medium capitalize-first">
            {{ option[displayKey] }}
          </span>
          <FontAwesomeIcon
            v-show="checked"
            :icon="['fas', 'circle-check']"
            class="shrink-0 text-white/80"
            size="lg"
          />
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Radio group shown as large red cards, as the cremation type choice.
 * `v-model` is the option's `trackBy` value; `change` also carries
 * `{ attribute: name, value }` for the forms' `getInputValue` handlers.
 */
export default {
  name: 'BaseRadioCards',
  components: {
    FontAwesomeIcon,
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption
  },
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      required: false,
      default: null
    },
    options: { type: Array, required: false, default: () => [] },
    name: { type: String, required: false, default: null },
    label: { type: String, required: false, default: null },
    trackBy: { type: String, required: false, default: 'id' },
    displayKey: { type: String, required: false, default: 'name' },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    onUpdate(value) {
      this.$emit('update:modelValue', value)
      this.$emit('change', { attribute: this.name, value })
    }
  }
}
</script>
